import { graphql } from "../gql";

// Submit custom task mutation

export const submitMutation = graphql(`
    mutation AppSubmitCustomTaskMutation($kind: String!, $answer: String!) {
        submitCustomTask(kind: $kind, answer: $answer) {
            error
            redirect
            submittedTask {
                id
                learningPathItem {
                    id
                    learningPath {
                        id
                    }
                }
            }
        }
    }
`);

// Rejected task query

export const query = graphql(`
    query AppCustomTaskSubmittedTaskQuery($id: ID!) {
        submittedTask(id: $id) {
            id
            kind
            name
            icon
            submittedTaskVariant {
                id
                variantType
                variantTitle
                description
                eventStart
                eventEnd
                taskQuestions {
                    id
                    answerType
                    questionContent
                }
            }
            learningPathItem { id }
            thread {
                id
                type
                subtype
                contentFormat
                content
                scaleScore {
                    earnedScore
                    possibleScore
                }
                person {
                    id
                    firstName
                    lastName
                    profilePicSrc
                }
                taskAnswers {
                    id
                    answerType
                    questionContent
                    answerContent
                    checkboxAnswers {
                            id
                            content
                            checked
                        }
                    taskLikertAnswers {
                            id
                            statement
                            leftLabel
                            rightLabel
                            value
                        }
                    showPollResults
                    quizAnswerSet {
                        id
                        results
                        answers {
                            id
                            answer
                            answeredQuestion {
                                id
                                number
                                levelNumber
                                description
                                correctAnswer
                                explanation
                                quizOptions {
                                    id
                                    letter
                                    content
                                }
                            }
                        }
                    }
                    pollAnswerSet {
                        id
                        pollAnswerCount
                        answers {
                            id
                            answers
                            question {
                                id
                                number
                                content
                                chartType
                                options {
                                    id
                                    number
                                    content
                                    answerCount
                                }
                            }
                        }
                    }
                    taskAnswerFile {
                        id
                        logoSrc
                        src
                        name
                    }
                    impactTrackerAnswerSet {
                        id
                        impactLikertAnswers {
                            id
                            statement
                            leftLabel
                            rightLabel
                            value
                        }
                    }
                    selectInImageMedia {
                        id
                        mediaType
                        src
                        name
                    }
                    imageSelectionAnswers {
                        id
                        part
                        clickX
                        clickY
                        answerType
                        answer
                        explanation
                    }
                    imageSelectionScore {
                        earnedScore
                        possibleScore
                    }
                }
            }
        }
    }
`);

// Submit rejected task mutation

export const rejectedMutation = graphql(`
    mutation AppSubmitCustomRejectedTaskMutation($taskId: ID!, $answer: String!) {
        submitCustomRejectedTask(taskId: $taskId, answer: $answer) {
            error
            redirect
            submittedTask {
                id
                learningPathItem {
                    id
                    learningPath {
                        id
                    }
                }
            }
        }
    }
`);
